import { baseApi } from 'components/constants/Constants';
import { ContentPage } from 'types/global';
import { useAxiosWithAuth } from '../useAxios';
import { usePaginatedAxios } from '../usePaginatedAxios';

export type CustomContact = {
  email_address: string;
  manufacturer: string;
  distributor: string;
  factory: string;
};

type Response = {
  content: CustomContact[];
  page: ContentPage;
};

export const useCustomContacts = (portalKey: string) =>
  useAxiosWithAuth<Response>(
    {
      url: `${baseApi}/portals/${portalKey}/custom-contacts`,
      method: 'GET'
    },
    { manual: true }
  );

export const useCustomContactsPaginated = (portalKey: string) => {
  const result = usePaginatedAxios<CustomContact>(
    {
      url: `${baseApi}/portals/${portalKey}/custom-contacts`,
      method: 'GET'
    },
    [
      'manufacturer__icontains',
      'distributor__icontains',
      'factory__icontains',
      'email_address__icontains'
    ]
  );

  return result;
};
